module.exports = __webpack_public_path__ + "static/media/premium.6fb45494.jpg";